var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBooking = function SvgBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 22.5a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-10.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z",
    fill: "#376C65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.942 18.75 15 16.808V13.5h1.5v2.692l1.5 1.5-1.058 1.058Z",
    fill: "#376C65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5A1.5 1.5 0 0 0 19.5 3h-3V1.5H15V3H9V1.5H7.5V3h-3A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h3v-1.5h-3v-15h3V6H9V4.5h6V6h1.5V4.5h3V9H21V4.5Z",
    fill: "#376C65"
  })));
};

export default SvgBooking;